// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgp_a bho_bi"};